import axios from 'axios';
import config from '../config';
import Countries from '../constants/countries';
var cardApi = axios.create({
    baseURL: config.apiUrl,
    withCredentials: true,
    headers: {
        Tenant: Countries.ARGENTINA
    }
});
export var CardApiClient = {
    get: cardApi.get,
    post: cardApi.post,
    put: cardApi.put,
    patch: cardApi.patch,
    delete: cardApi.delete
};
export function setCardTenant(tenant) {
    cardApi.defaults.headers.Tenant = tenant;
}
